// Lesson 1.2 
//Section:Новые слова: цифры 0-10 
export const NWset1 = [
  {
    rus: 'Сколько',
    eng: 'How many or How much',
    partOfSpeech: 'numeral',
    note: '<strong>How much</strong> in English is used for <strong>uncountable</strong> nouns, for example with <strong>sugar</strong> or <strong>salt</strong> you should use <strong>how much</strong>. In Russian <em>Сколько</em> is used both for uncountable and countable nouns.'
  }
];


export const NWset2 = [
  {
    rus: 'Меня зовут',
    eng: 'My name is',
    partOfSpeech: 'phrase',
    note: '<strong>Меня зовут + name</strong> literally means <strong>I am called</strong>.'
  }
];

export const NWset3 = [
  {
    rus: 'Тебе нужно',
    eng: 'You need'
  },
  {
    rus: 'Узнать данные',
    eng: 'Get data'
  }
];


// Lesson 2.1
// Explanation of what is year
export const NWset4 = [
  {
    rus: 'год',
    eng: 'year',
    note: `When we talk about duration, we use <strong>год</strong> with number 1. For example, <strong>1 год</strong>. With numbers 2,3,4 we use <strong>года</strong>. And for numbers 5 and more we use <strong>лет</strong>. For instance, <strong>5 лет</strong>,<strong>6 лет</strong>,<strong>7 лет</strong>,<strong>8 лет</strong> etc. Depending on what number is the last we use respective word. For exapmle 2<strong>1</strong> год, 2<strong>3</strong> года, 3<strong>5</strong> лет `
  }
];

// Lesson 2.1
// Explanation of what is prepositional case
export const NWset5 = [
  {
    rus: 'Предложный падеж',
    eng: 'Prepositional case',
    note: `The <strong>prepositional case</strong> is used to designate the place. The nouns answering the question "where" are often used with the prepositions <strong>в (in)</strong> and <strong>на (on)</strong>`
  }
];

// Lesson 2.1
// Explanation of what is instrumental case
export const NWset6 = [
  {
    rus: 'Творительный падеж',
    eng: 'Instrumental case',
    note: `We use the verbs <strong>быть</strong> (to be), <strong>стать</strong> (to become) and <strong>работать</strong> (to work) with the Instrumental case`
  }
];

// Lesson 2.1
// Explanation of using prepositional case with "home" and "work"
export const NWset7 = [
  {
    rus: 'Дома',
    eng: 'at home'
  },
  {
    rus: 'На работе',
    eng: 'at work',
    note: `We use **дома** *not* **в доме** to say that we eat there, and the same with **на работе** *not* **в работе**`
  }
];

export const NWset8 = [
  {
    rus: 'месторождения',
    eng: 'birthplace'
  },{
    rus: 'место проживания',
    eng: 'place of living'
  },{
    rus: 'навыки',
    eng: 'skills'
  },
  {
    rus: 'откуда он / она?',
    eng: 'where is he / she from?'
  },
  {
    rus: 'сколько ей / ему лет?',
    eng: 'how old is he / she?'
  },
  {
    rus: 'что его / её интересует?',
    eng: 'what does interest him / her?'
  },
  {
    rus: 'что он / она знает?',
    eng: 'what does he / she know?'
  },
  {
    rus: 'на каких языках он / она говорит?',
    eng: 'what languages does he / she speak?'
  }
];

export const NWset9 = [
  {
    rus: 'В Германии (Германия)',
    eng: 'In Germany',
    note: `When we use **prepositional case** with a country (for example, **in Germany**) that ends with **<em>ия</em>**, for example Герман**ия** it changes to Герман**ии**`
  },
  {
    rus: 'В Казахстане (Казахстан)',
    eng: 'In Kazakhstan',
    note: `When we use prepositional case with a country (for example, **in Kazakhstan**) that ends with with **consonant**, for example Казахста**н** we add **е** to the last consonant Казахстан**е**`
  },
  {
    rus: 'В Украине (Украина)',
    eng: 'In Ukraine',
    note: `When we use prepositional case with a country (for example, **in Ukraine**) that ends with with **а**, for example Украин**а** we change **а** to **е**, Украине**е**`
  },
  {
    rus: 'Из Афганистана (Афганистан)',
    eng: 'From Afganistan',
    note: `When we use genitive case with a country (for example, **from Afganistan**) that ends with with consonant **н**, for example Афганиста**н** we add **а** to the last consonant, Афганистан**а**`
  },
  {
    rus: 'Из Украины (Украина)',
    eng: 'From Ukraine',
    note: `When we use genitive case with a country (for example, **from Ukraine**) that ends with with **а**, for example Украин**а** we change **а** to **ы**, Украин**ы**`
  },
  {
    rus: 'Из Швеции (Швеция)',
    eng: 'From Sweden',
    note: `When we use genitive case with a country (for example, **from Sweden**) that ends with with **ия**, for example Швеци**ия** we change **ия** to **ии**, Швец**ии**`
  },
  {
    rus: 'Она говорит на Английском (Английский)',
    eng: 'She speaks English',
    note: `When we say that a person speaks a language we use instrumental case, so that if a language end with **ий**, for example Английск**ий**, we change it to **ом**, so it becomes Английск**ом**`
  }
];